import script from "./Modal.vue?vue&type=script&lang=ts&setup=true"
export * from "./Modal.vue?vue&type=script&lang=ts&setup=true"

import "./Modal.vue?vue&type=style&index=0&id=638ee228&lang=scss"

const __exports__ = script;

export default __exports__